import * as React from "react";
const SvgFiRrCricket = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cricket_svg__a)">
      <path
        fill="#062147"
        d="M16.722 11a2.5 2.5 0 0 1-.222-1.02c.012-.71.303-1.386.811-1.88l4.19-4.187.793.793a1 1 0 0 0 1.413-1.414l-3-3a1 1 0 0 0-1.413 1.414l.793.793L15.9 6.69c-.486.5-1.149.79-1.847.81A2.4 2.4 0 0 1 13 7.275a3.04 3.04 0 0 0-3.418.578L.917 16.517a3 3 0 0 0-.853 1.711 5.05 5.05 0 0 0 1.3 4.405A4.84 4.84 0 0 0 4.87 24q.453 0 .9-.064a3 3 0 0 0 1.71-.852l8.665-8.663a3.05 3.05 0 0 0 .578-3.42m-4.538-1.9a4.47 4.47 0 0 0 2.347.37q-.03.255-.03.512c.001.629.135 1.25.393 1.823a1.14 1.14 0 0 1 0 .976 4.3 4.3 0 0 0-2.47-.782 1.4 1.4 0 0 1-.378-.03.64.64 0 0 1-.045-.3 4.34 4.34 0 0 0-.78-2.57c.144-.073.304-.11.466-.11a1.2 1.2 0 0 1 .498.11M6.067 21.667a1 1 0 0 1-.577.286 3.12 3.12 0 0 1-2.709-.735 3.12 3.12 0 0 1-.735-2.708c.03-.219.13-.422.286-.58l7.413-7.413c.175.36.263.755.257 1.154A2.166 2.166 0 0 0 12.414 14c.371 0 .738.087 1.07.253zM20.501 17a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m0 5a1.5 1.5 0 1 1 0-2.999 1.5 1.5 0 0 1 0 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cricket_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCricket;
